import "../styles/app/app.scss";

import React, { useEffect } from "react";
import routes from "./routes";
import { RouterProvider, useNavigation } from "react-router-dom";
import AppProvider from "./appContext";
import { iconHandler } from "../app/common/fontAwesomeIcons";
import { NotificationContainer } from "react-notifications";
import config from "config";
const { companyName } = config;

function App() {
  useEffect(() => {
    document.getElementById("fabIcon").href = `/assets/images/Logo/demo.gif`;
    // document.getElementById("documentTitle").innerHTML = `${companyName}`;
    document.getElementById("documentTitle").innerHTML = `Chandni Online`;
  }, []);

  iconHandler();
  return (
    <AppProvider>
      <RouterProvider router={routes} />
      <NotificationContainer />
    </AppProvider>
  );
}

export default App;
